export default __webpack_public_path__ + "static/media/ProductIllustration.90883aa4.svg";